import { ENV_CONFIG } from '@/config/envs'
import { mapMutations, mapState } from 'vuex'
import planApi from '@/services/planApi'

export default {
  data() {
    return {
      priceIds: {
        brl: {
          stg: 'price_1QNxkhA9gXMNgQ3rnoy0OTr5',
          prd: 'price_1QNxhzA9gXMNgQ3r49aQS7Gl',
        },
        usd: {
          stg: 'price_1QPOG1GSWmZaFqRVqm4vsrFe',
          prd: 'price_1QPOGoGSWmZaFqRVFKW4zvww',
        },
      },
    }
  },
  computed: {
    ...mapState('user', {
      userPlanInfo: (state) => state.userPlanInfo,
    }),
    isBrl() {
      return this.userPlanInfo.currency === 'brl'
    },
    isStaging() {
      return ENV_CONFIG !== 'production'
    },
    priceId() {
      const env = this.isStaging ? 'stg' : 'prd'
      const currency = this.isBrl ? 'brl' : 'usd'
      return this.priceIds[currency][env]
    },
  },
  watch: {
    userPlanInfo: {
      handler(planInfo) {
        const traffic = planInfo.addons.traffic
        if (traffic) {
          this.checkPandaBrandingBonus(traffic)
        } else {
          this.UPDATE_USER_LOGO_BONUS(false)
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_LOGO_BONUS', 'UPDATE_USER_ADDONS']),
    async checkPandaBrandingBonus(traffic) {
      const hasBonusEnabled = (item) => item.price_id === this.priceId
      const isBonusEnabled = traffic.some(hasBonusEnabled)
      this.UPDATE_USER_LOGO_BONUS(isBonusEnabled)
    },
    async getSubscriptionAddonsData() {
      try {
        const ret = await planApi.getSubscription()
        const addons = ret.data.addons
        this.UPDATE_USER_ADDONS(addons)
        return addons
      } catch (e) {
        console.log(e)
        return e
      }
    },
  },
}
